import { render } from "./cardAssetRecordModel.vue?vue&type=template&id=3764be86"
import script from "./cardAssetRecordModel.vue?vue&type=script&lang=js"
export * from "./cardAssetRecordModel.vue?vue&type=script&lang=js"

import "./cardAssetRecordModel.vue?vue&type=style&index=0&id=3764be86&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__